export default __webpack_public_path__ + "static/media/Group 2136.b9f8557a.svg";